var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0499 16.6682L21.5998 8.60156C21.1165 7.01823 18.8832 7.01823 18.4165 8.60156L15.9498 16.6682H8.53318C6.91652 16.6682 6.24985 18.7516 7.56652 19.6849L13.6332 24.0182L11.2498 31.7016C10.7665 33.2516 12.5665 34.5016 13.8499 33.5182L19.9998 28.8516L26.1498 33.5349C27.4332 34.5182 29.2332 33.2682 28.7498 31.7182L26.3665 24.0349L32.4332 19.7016C33.7498 18.7516 33.0832 16.6849 31.4665 16.6849H24.0499V16.6682Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 7.41406C19.3236 7.41482 18.6496 7.81065 18.4165 8.60156L15.9498 16.6682H8.53318C6.91652 16.6682 6.24985 18.7516 7.56652 19.6849L13.6332 24.0182L11.2498 31.7016C10.7665 33.2516 12.5665 34.5016 13.8499 33.5182L19.9999 28.8516L20 28.8517V7.41406Z",
    fill: "#FBBB4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStar);
export default __webpack_public_path__ + "static/media/half-star.4bebf1720a7dacc7978599c75b1b2035.svg";
export { ForwardRef as ReactComponent };